module.exports = __webpack_public_path__ + "static/media/document.59318b15.svg";